var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { WhiteLabel } from '@/models/WhiteLabel';
import ErrorHandler from '@/support/ErrorHandler';
import { Component, Vue } from 'vue-property-decorator';
let CreateDialog = class CreateDialog extends Vue {
    constructor() {
        super(...arguments);
        this.whiteLabel = new WhiteLabel();
        this.isLoading = false;
        this.currentStep = 1;
        this.rules = {
            required: (value) => !!value || 'Verplicht.',
            slug: (value) => {
                const pattern = /^[a-z0-9\-]+$/;
                return pattern.test(value) || 'Alleen kleine letters, cijfers en streepjes.';
            },
        };
    }
    close() {
        this.$emit('input', false);
    }
    get isValid() {
        return !!(this.whiteLabel.name &&
            this.whiteLabel.name.length &&
            this.whiteLabel.slug &&
            this.whiteLabel.slug.length);
    }
    async create() {
        if (!this.isValid)
            return;
        this.isLoading = true;
        this.currentStep = 3;
        try {
            await this.whiteLabel.create();
            this.$emit('created');
        }
        catch (error) {
            ErrorHandler.network(error);
            this.currentStep = 1;
        }
        finally {
            this.isLoading = false;
        }
    }
};
CreateDialog = __decorate([
    Component({})
], CreateDialog);
export default CreateDialog;
